<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['name',{ rules: [{ required: true, message: '请输入名称' }] }]"
            name="name"
            placeholder="请输入名称"
          />
        </a-form-item>
        <a-form-item label="代码仓地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['code_url']"
            name="code_url"
            placeholder="请输入代码仓地址"
          />
        </a-form-item>
        <a-form-item label="官网地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['web_url']"
            name="web_url"
            placeholder="请输入官网地址"
          />
        </a-form-item>
        <a-form-item label="项目top栏（非必须）" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <img-upload
              name="image"
              v-decorator="['image',]"
            />
          </a-form-item>
        <a-form-item label="捐赠主体" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['donating_entity']"
            name="donating_entity"
            placeholder="请输入捐赠主体"
          />
        </a-form-item>
        <a-form-item label="贡献主体" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['contribute_entity']"
            name="contribute_entity"
            placeholder="请输入贡献主体"
          />
        </a-form-item>
        <a-form-item label="技术特点" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['technical']"
            name="technical"
            placeholder="请输入技术特点"
          />
        </a-form-item>
        <a-form-item label="项目sponsor" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['sponsor']"
            name="sponsor"
            placeholder="请输入项目sponsor"
          />
        </a-form-item>
        <a-form-item label="项目价值(建议不超过30个汉字）" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['project_value']"
            name="project_value"
            placeholder="请输入项目价值"
          />
        </a-form-item>
        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="project_desc"
            placeholder="请输入简介"
            v-decorator="['project_desc',{ rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="下载项目地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['download_url']"
            name="download_url"
            placeholder="请输入下载项目地址"
          />
        </a-form-item>
        <a-form-item label="项目代码地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['project_url']"
            name="project_url"
            placeholder="请输入项目代码地址"
          />
        </a-form-item>
        <a-form-item label="项目社区地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['community_url']"
            name="community_url"
            placeholder="请输入项目社区地址"
          />
        </a-form-item>
        <a-form-item label="项目LOGO" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <img-upload
            name="thum"
            v-decorator="['thum']"
          />
        </a-form-item>
        <a-form-item label="star数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="star"
            v-decorator="[
              'star',
              {
                initialValue: 0,
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="Contributor数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="contributor"
            v-decorator="[
              'contributor',
              {
                initialValue: 0,
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="Fork数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="fork"
            v-decorator="[
              'fork',
              {
                initialValue: 0,
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="PR数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="pr"
            v-decorator="[
              'pr',
              {
                initialValue: 0,
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="Commits数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="commits"
            v-decorator="[
              'commits',
              {
                initialValue: 0,
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="Watch数量	" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            name="watch"
            v-decorator="[ 'watch',
              { initialValue: 0 }
            ]"
          />
        </a-form-item>
        <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
          <u-editor
            name="contents"
            v-decorator="['contents']"
          />
        </a-form-item>
        <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="selectLoading">
            <a-select
              placeholder="请选择分类"
              style="width: 100%"
              name="typeid"
              optionFilterProp="children"
              allow-clear
              v-decorator="['typeid',{ rules: [{ required: true, message: '请选择分类' }] }]"
            >
              <a-select-option v-for="d in selectList" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
          <a-input-number
            name="sort"
            v-decorator="[
              'sort',
              {
                initialValue: 0
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button
            :loading="formLoading"
            type="primary"
            @click="handleSubmit(setFormData)"
          >提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { UEditor, GoBack, ImgUpload } from '@/components'
import { form, select } from '@/mixins'
const fields = ['date', 'state', 'name', 'code_url', 'web_url', 'image', 'donating_entity', 'contribute_entity', 'technical', 'sponsor', 'project_value', 'project_desc', 'download_url', 'project_url', 'community_url', 'thum', 'star', 'contributor', 'fork', 'pr', 'commits', 'watch', 'contents', 'typeid', 'sort']
const apiList = {
    getInfo: '/opensource/finds/',
    create: '/opensource/create',
    update: '/opensource/'
}
export default {
    name: 'projectForm',
    mixins: [form, select],
    components: {
        UEditor,
        GoBack,
        ImgUpload
    },
    data () {
        return {
            apiList,
            fields,
            selectLoading: false, // 分类下拉加载
            selectList: [
              {
                id: 1,
                value: 1,
                name: '孵化期项目'
              },
              {
                id: 2,
                value: 2,
                name: '孵化筹备期'
              }
            ] // 分类下拉数据
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.date = that.moment(values.date) // 日期格式转换
                values.state = values.state === 1 // 状态格式转换
            }) // 获取编辑信息
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-25 16:14:35
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.date = this.moment(values.date).format('YYYY-MM-DD') // 日期格式转换
            // values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
            console.log('values:')
            console.log(values)
        }
    }
}
</script>
